var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":"","text-color":"white","color":_vm.getColor}},[_vm._v(" "+_vm._s(_vm.getLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }